@let exception = exceptionDetails$ | async;
@let createdBy = exception?.createdBy?.id | teamMemberName | async;
@let updatedBy = exception?.updatedBy?.id | teamMemberName | async;

@if (!exception) {
  <app-details-page-header-placeholder [pageReturnURL]="pageReturnURL" />

  <app-details-page-content-placeholder [singleColumn]="true" />
} @else {
  <app-details-page-header
    [pageReturnURL]="pageReturnURL"
    [title]="exception.id | rktShortId"
    [status]="exception.status"
    [breadcrumbs]="breadcrumbs"
  />

  <div class="flex gap-5 mb-5">
    <div class="bg-white rounded-lg px-6 py-5 mt-5 flex-1">
      <div class="grid gap-x-16 gap-y-5 w-full xl:w-2/3 lg:grid-cols-2">
        <app-assignee-select
          [selectedAssignee]="selectedAssignee"
          [selectedItem]="selectedAssignee?.value ?? 'UNASSIGNED'"
          [businessAccountId]="exception?.businessAccountId"
          (changed)="setSelectedAssignee($event)"
          (closed)="updateException(exception)"
        ></app-assignee-select>

        <app-status-select
          [selectedItem]="selectedStatus ?? ''"
          [items]="statusOptions"
          [disabled]="!!!exception?.assignedTo?.id"
          (changed)="setSelectedStatus($event)"
          (closed)="updateException(exception)"
        ></app-status-select>
      </div>

      <div class="separator"></div>

      <div class="grid gap-x-16 gap-y-5 w-full xl:w-2/3 lg:grid-cols-2">
        <app-details-item label="Exception ID" [value]="exception?.id || '' | rktShortId"></app-details-item>

        <app-details-item label="Unique ID" [value]="exception?.entityId || '' | rktShortId"></app-details-item>

        <app-details-item label="Exception Category" [value]="exception?.categoryLabel"></app-details-item>

        <app-details-item label="Exception Type" [value]="exception?.typeLabel"></app-details-item>

        <app-details-item label="Description" [value]="exception?.description"></app-details-item>
      </div>
    </div>
  </div>

  <div class="exception-layout exception-layout-with-side-panel" *ngIf="exception">
    <div class="exception-layout-section">
      <div class="entity-details-container">
        <app-notes-feed [entityId]="exception.id" entityType="EXCEPTION" [businessAccountId]="exception.businessAccountId"></app-notes-feed>
      </div>
    </div>

    <div class="exception-layout-section">
      <div class="entity-details-container">
        <div class="details-col">
          <app-details-item label="Created At" [value]="exception?.createdAt | dateFormat"></app-details-item>

          <app-details-item label="Created By" [value]="createdBy" />
        </div>

        <div class="separator"></div>

        <div class="details-col">
          <app-details-item label="Updated At" [value]="exception?.updatedAt | dateFormat"></app-details-item>

          <app-details-item label="Updated By" [value]="updatedBy" />

          <app-details-item label="Updated" [value]="(exceptionHistory$ | async)?.[0]?.description"></app-details-item>
        </div>

        <button rktButton btnType="link" class="view-history-btn" (click)="showHistoryModal()">
          <rkt-icon name="clock"></rkt-icon>
          View History
        </button>
      </div>
    </div>
  </div>
}
